/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class CorpNewsYears extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        onMouseMove: PropTypes.func,
    };

    render() {
        const {
            onMouseMove,
            content: { newsYears },
        } = this.props;

        return (
            <div className={styles.record_txt}>
                <ul id="years">
                    {newsYears.map((item, index) => {
                        return (
                            <li key={index}>
                                <a href="javascript:void(0);" title={index} onMouseMove={() => onMouseMove(index)}>
                                    {item.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default CorpNewsYears;
